export default __webpack_public_path__ + "static/download-token-5fe122f3ca34e1bec318fb73e3646141.webp";